import { useEffect, useState } from "react";
import {jwtDecode} from "jwt-decode";

export const useAuthentication = () => {
  const storedUserData = JSON.parse(localStorage.getItem("logindata") || "{}");
  const initialToken = storedUserData?.data?.token || "";

  const [isAuthenticated, setIsAuthenticated] = useState(!!initialToken);
  const [token, setToken] = useState(initialToken);
  const [username, setUsername] = useState(null);
  const [role, setRole] = useState(null);

  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp && decoded.exp < currentTime) {
        removeToken(); 
        return;
      }

      setUsername(decoded.username || null);
      setRole(decoded.role || null);
    } catch (error) {
      console.error("Error decoding token:", error);
      removeToken(); 
    }
  };

  const removeToken = () => {
    localStorage.removeItem("logindata");
    setIsAuthenticated(false);
    setToken(null);
    setUsername(null);
    setRole(null);
  };

  const checkAuth = () => {
    const data = JSON.parse(localStorage.getItem("logindata") || "{}");
    const token = data?.data?.token || "";

    if (!token) {
      removeToken();
      return;
    }

    setIsAuthenticated(!!token);
    setToken(token);

    decodeToken(token);
  };

  useEffect(() => {
    checkAuth();

    const handleAuthChange = () => checkAuth();

    window.addEventListener("storage", handleAuthChange);
    window.addEventListener("authChange", handleAuthChange);

    return () => {
      window.removeEventListener("storage", handleAuthChange);
      window.removeEventListener("authChange", handleAuthChange);
    };
  }, []);

  return { isAuthenticated, token, username, role };
};
